import { useEffect, useState, SyntheticEvent } from "react";
import { Box, pn } from "@compass/core";
import { Select } from "components";
import {
    StudentFilter as StudentFilterModel,
    StudentFilterResource,
    LkStudentDisplayFilterId,
    SimpleDto,
} from "generated/openApi";
import ApiService from "services/apiService";
import { useEligibilityData } from "../contexts/EligibilityDataContext";

export const EligibilityFilterControls = () => {
    const { filter, updateFilter, activeSchoolYear } = useEligibilityData();
    const [resource, setResource] = useState<StudentFilterResource | undefined>(undefined);

    useEffect(() => {
        ApiService.students.getFilterResource().then(setResource);
    }, []);

    const showProgramFilter = resource?.displayFilters?.some(
        (x) => x.id === LkStudentDisplayFilterId.Program
    ) ?? false;

    const selectedYear = filter.schoolYear ?? activeSchoolYear;
    const programPropertyName = pn<StudentFilterModel>("programIds");
    const programProperty = resource?.properties?.find(
        (x) => x.propertyName === programPropertyName
    );

    return (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
            <Box sx={{ minWidth: 180, maxWidth: 240, flex: "1 1 180px" }}>
                <Select
                    label="School Year"
                    value={resource?.schoolYearsWithActive?.find((x) => x.id === selectedYear)}
                    options={resource?.schoolYearsWithActive}
                    getOptionLabel={(o: SimpleDto) => o.name}
                    onChange={(_e: SyntheticEvent, v: SimpleDto | null) =>
                        updateFilter({ schoolYear: v?.id ?? undefined })
                    }
                    size="small"
                />
            </Box>
            {showProgramFilter && (
                <Box sx={{ minWidth: 180, maxWidth: 240, flex: "1 1 180px" }}>
                    <Select
                        modelProperty={programProperty}
                        value={resource?.programs?.find((x) => x.id === filter.programId)}
                        options={resource?.programs}
                        getOptionLabel={(o: SimpleDto) => o.name}
                        onChange={(_e: SyntheticEvent, v: SimpleDto | null) =>
                            updateFilter({ programId: v?.id ?? undefined })
                        }
                    />
                </Box>
            )}
        </Box>
    );
};